/* eslint-disable no-useless-escape */
// returns the cookie with the given name,

import {APP_ROOT_HOSTNAME} from "../const/Configuration";

// or undefined if not found
export const getCookie = (name) => {
  let matches = document.cookie.match(
    new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)")
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const setCookie = (name, value, options = {}) => {
  options = {
    path: "/",
    domain: APP_ROOT_HOSTNAME,
    // add other defaults here if necessary
    ...options,
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }
  document.cookie = updatedCookie;
};

// Example of use:
// cookie will die in +1 hour from now
// setCookie('user', 'John', {secure: true, 'max-age': 3600});

// let date = new Date();
// date.setHours(23, 59, 59, 999);
// date = date.toUTCString();
// setCookie('user', 'John', selectedMenuName, { secure: true, expires: date });

export const deleteCookie = (name) => {
  setCookie(name, "", {
    "max-age": -1,
  });
};
